import { render, staticRenderFns } from "./AccountInformation.vue?vue&type=template&id=36824256&scoped=true&"
import script from "./AccountInformation.vue?vue&type=script&lang=js&"
export * from "./AccountInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36824256",
  null
  
)

export default component.exports